import { render, staticRenderFns } from "./assetitem.vue?vue&type=template&id=10007503"
import script from "./assetitem.vue?vue&type=script&lang=js"
export * from "./assetitem.vue?vue&type=script&lang=js"
import style0 from "./assetitem.vue?vue&type=style&index=0&id=10007503&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports